module.exports = __webpack_public_path__ + "img/a.d6db6a80.png";